// OurWork.jsx
import React from "react";

const projects = [
    {
        name: "Bar Caligo",
        type: "Cocktail Bar • NYC",
        tagline: "Moody, high-contrast look with late‑night menu focus.",
        highlights: ["Fast menu swaps", "Seasonal banners", "Google Business sync"],
    },
    {
        name: "Morning Parade Café",
        type: "Café • Weekday Brunch",
        tagline: "Warm, airy layout with daily pastry board and coffee pairings.",
        highlights: ["Daily specials", "Allergen flags", "Simple online ordering"],
    },
    {
        name: "Tide & Tonic Oyster Co.",
        type: "Seafood • Oyster Happy Hour",
        tagline: "Clean typography, hero photography, and reservation forward.",
        highlights: ["Reservations CTA", "Event popups", "Schema for menus"],
    },
    {
        name: "Static Bar",
        type: "Dive‑style Cocktail • East Village",
        tagline: "Grunge‑meets‑clean UI with late‑night hours emphasis.",
        highlights: ["After‑hours menu", "Promo codes", "Press carousel"],
    },
    {
        name: "Maison Verdant",
        type: "Bistro • Natural Wine",
        tagline: "Editorial feel with map‑first footer and rotating chef’s menu.",
        highlights: ["Course builder", "Wine list filters", "Newsletter capture"],
    },
    {
        name: "Delta Devil BBQ",
        type: "Casual • Counter Service",
        tagline: "Bold, high‑contrast UI with combo builder and pickup flow.",
        highlights: ["Pickup flow", "Combo pricing", "Reviews integration"],
    },
];

export default function OurWorkHero() {
    return (
        <main className="ourwork">
            <section className="work-hero">
                <div className="container work-hero__inner">
                    <span className="eyebrow">Our Work</span>
                    <h1 className="results-title">Sample builds designed for hospitality</h1>
                    <p className="results-sub">Concept demos that show exactly how a Nectr Studio site can look and feel.</p>
                </div>
            </section>

            <section className="work-grid__section">
                <div className="container work-grid">
                    {projects.map((p) => (
                        <article className="work-card" key={p.name}>
                            {/* Replace the div below with <img className="work-shot" src="/shots/serpente.jpg" alt={`Homepage design for ${p.name}`} /> */}
                            <a className="work-shot work-shot--link" href={`/work/${slugify(p.name)}`} aria-label={`${p.name} concept demo`}>
                                <span className="work-badge">Concept</span>
                                <div className="work-shot__chrome"><span/><span/><span/></div>
                                <div className="work-shot__brand">{p.name}</div>
                            </a>

                            <div className="work-meta">
                                <h3 className="work-title">{p.name}</h3>
                                <p className="work-type">{p.type}</p>
                                <p className="work-tagline">{p.tagline}</p>
                                <ul className="work-tags">
                                    {p.highlights.map((h) => <li key={h}>{h}</li>)}
                                </ul>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            {/* Single global CTA */}
            {/*<section className="work-cta-row">*/}
            {/*    <div className="container text-center">*/}
            {/*        <a href="/get-started" className="btn btn-accent-primary btn-lg">Get Started</a>*/}
            {/*        <p className="results-footnote">Tell us your business name and what you’re looking for — we’ll follow up fast.</p>*/}
            {/*    </div>*/}
            {/*</section>*/}
        </main>
    );
}

function slugify(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}
